import './App.css';
import NavigationFooter from "./Pages/Landing/NavigationFooter";
import {Route, Routes} from "react-router-dom";
import Landing from "./Pages/Landing/Landing";
import Services from "./Pages/Landing/Services";
import Products from "./Pages/Landing/Products";
import About from "./Pages/Landing/About";
import Contact from "./Pages/Landing/Contact";
import ScrollToTop from "./Pages/utils/ScrollToTop";

function App() {

    return (

        <ScrollToTop>
            <Routes>
                <Route key={"landing"} path="" element={<NavigationFooter>
                    <Landing/>
                </NavigationFooter>}/>
                <Route key={"services"} path="/services" element={<NavigationFooter>
                    <Services/>
                </NavigationFooter>}/>
                <Route key={"products"} path="/products" element={<NavigationFooter>
                    <Products/>
                </NavigationFooter>}/>
                <Route key={"about"} path="/about" element={<NavigationFooter>
                    <About/>
                </NavigationFooter>}/>
                <Route key={"contact"} path="/contact" element={<NavigationFooter>
                    <Contact/>
                </NavigationFooter>}/>
            </Routes>
        </ScrollToTop>

    );
}


export default App;
